import {
  Component,
  ElementRef,
  HostListener,
  inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from "@angular/router";
import { ThemeDirective } from "./theme/theme.directive";
import { ContactUsComponent } from "./shared/components/contact-us/contact-us.component";
import { QeleoIconComponent } from "./shared/components/qeleo-icon/qeleo-icon.component";
import { NavigationFooterComponent } from "./shared/components/navigation-footer/navigation-footer.component";
import { CommonModule, ViewportScroller } from "@angular/common";
import { ModalService } from "./core/services/modal.service";
import { ScreenSizeService } from "./core/services/screen-size.service";
import { HEADER_NAV_ARRAY } from "./constants/constants";
import { ContactFormComponent } from "./shared/modals/contact-form/contact-form.component";
import {ToastComponent} from "./shared/modals/toast/toast.component";
import {environment} from "../environments/environment";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    ThemeDirective,
    ContactUsComponent,
    QeleoIconComponent,
    NavigationFooterComponent,
    CommonModule,
    ToastComponent
  ],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent {
  navModal: any;
  headerNavArr: any[] = [...HEADER_NAV_ARRAY];
  @ViewChild("navModalRef") navModalRef?: any;
  hideContactForArr: string[] = ["/about", "/insights/", "/ethics"];
  hideContactUsComponent: boolean = false;
  private router = inject(Router);
  private modalService = inject(ModalService);

  ngOnInit() {
    console.log("enviornment", environment.API_URL);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.hideContactUsComponent = this.hideContactForArr.some(
          (string: any) => event.url.includes(string)
        );
      }
    });
  }

  openContactModal() {
    this.modalService.show(ContactFormComponent, {}, "lg", true, "form-modal");
  }

  openNavModal() {
    this.navModal = this.modalService.show(
      this.navModalRef,
      {},
      "lg",
      false,
      "nav-modal-wrapper"
    );
  }

  onClose() {
    this.navModal.dismiss();
  }
}
